import React, { SVGProps } from 'react';
import SVGUniqueID from 'react-svg-unique-id';

interface ChevronLeftArrowIconProps extends SVGProps<SVGSVGElement> {
  width?: string;
  height?: number;
}

const ChevronLeftArrowIcon: React.FC<ChevronLeftArrowIconProps> = ({
  width = 20,
  height = 20,
  fill = '#475569'
}) => {
  return (
    <SVGUniqueID>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        fill={fill}
        viewBox="0 0 20 20"
        className="chevron-left-arrow-icon"
      >
        <path
          fillRule="evenodd"
          d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
          clipRule="evenodd"
        ></path>
      </svg>
    </SVGUniqueID>
  );
};

export { ChevronLeftArrowIcon };
